import "./App.css";
import Routers from "./Routers";
import { BrowserRouter, HashRouter } from "react-router-dom";
import Sidebar from "./pages/Sidebar/sidebar";
import AppToast from "./components/appToast";

function App() {
  return (
    <BrowserRouter>
      <AppToast />
      <Sidebar>
        <Routers />
      </Sidebar>
    </BrowserRouter>
  );
}

export default App;
